import GhostGuard from "app/presentation/components/guards/GhostGuard";

const mode = import.meta.env.VITE_APP_MODE || import.meta.env.MODE;

const isAuthAdmin = mode === 'admin' || mode === 'entreprise' || mode === 'admin-limited';

const getGhostRoutes = () => {
  if (isAuthAdmin) {
    return {
      id: "ghost",
      Component: GhostGuard,
      children: [
        {
          path: "login",
          lazy: async () => ({
            Component: (await import("app/presentation/features/auth/AdminLogin")).default,
          }),
        },
        {
          path: "login/admin",
          lazy: async () => ({
            Component: (await import("app/presentation/features/auth/AdminLogin")).default,
          }),
        },
        {
          path: "sign-up",
          lazy: async () => ({
            Component: (await import("app/presentation/features/auth/AdminSignUp")).default,
          }),
        },
      ],
    };
  }

  // Driver Mode
  return {
    id: "ghost",
    Component: GhostGuard,
    children: [
      {
        path: "login",
        lazy: async () => ({
          Component: (await import("app/presentation/features/auth/DriverLogin")).default,
        }),
      },
      {
        path: "login/driver",
        lazy: async () => ({
          Component: (await import("app/presentation/features/auth/DriverLogin")).default,
        }),
      },
      {
        path: "sign-up",
        lazy: async () => ({
          Component: (await import("app/presentation/features/auth/DriverSignUp")).default,
        }),
      },
    ],
  };
};

const ghostRoutes = getGhostRoutes();

export { ghostRoutes };